// extracted by mini-css-extract-plugin
module.exports = {"loadingBox":"LoadingBoxMobile_loadingBox_3igi5","loading":"LoadingBoxMobile_loading_2zR2Y","light":"LoadingBoxMobile_light_35Xod","tips":"LoadingBoxMobile_tips_12IS9"};